(function () {
  'use strict';

  if (window.relodeRacReviews) {
    window.relodeRacReviews.init(document);
    return;
  }

  const API = 'https://pixel-perfect-copy-2948.lovable.app/api/public/reviews/summary';
  const SELECTOR = '[data-rac-review-block]';
  const requests = new Map();
  const initialized = new WeakMap();

  function summarize(data) {
    if (!data || !Number.isInteger(data.count) || data.count < 0) {
      throw new Error('Invalid RAC summary count');
    }
    const average = data.count ? data.average : 0;
    if (!Number.isFinite(average) || (data.count && (average < 1 || average > 5))) {
      throw new Error('Invalid RAC summary rating');
    }
    const fit = data.fit;
    const validFit = data.count > 0 && fit && Number.isInteger(fit.count) && fit.count > 0 &&
      fit.count <= data.count && Number.isFinite(fit.average) && fit.average >= 1 && fit.average <= 3;

    return {
      count: data.count,
      average,
      sizeCount: validFit ? fit.count : 0,
      sizeAverage: validFit ? fit.average : null
    };
  }

  function requestSummary(handle, group) {
    const url = new URL(API);
    url.searchParams.set('handle', handle);
    url.searchParams.set('group', group);
    url.searchParams.set('lang', (document.documentElement.lang || 'sv').split('-')[0]);
    const key = url.href;

    // Share one summary request between blocks for this page visit.
    if (!requests.has(key)) {
      const controller = new AbortController();
      const timeout = window.setTimeout(() => controller.abort(), 15000);
      const request = window.fetch(key, {
        credentials: 'omit',
        signal: controller.signal
      }).then(response => {
        if (!response.ok) {
          throw new Error('RAC reviews request failed');
        }
        return response.json();
      }).then(summarize).finally(() => window.clearTimeout(timeout));
      requests.set(key, request);
    }

    return requests.get(key);
  }

  function renderStars(target, score) {
    const stars = target.querySelector('[data-rac-review-stars]');
    if (!stars) return;

    const full = Math.floor(score);
    const half = score - full > 0.05;
    const fragment = document.createDocumentFragment();

    for (let index = 0; index < 5; index++) {
      const type = index < full ? 'filled' : index === full && half ? 'half' : 'empty';
      const template = target.querySelector(`[data-rac-star="${type}"]`);
      if (template) fragment.appendChild(template.content.cloneNode(true));
    }
    stars.replaceChildren(fragment);
  }

  function sizeDescription(target, average) {
    const small = target.dataset.labelSmall || '';
    const perfect = target.dataset.labelPerfect || '';
    const large = target.dataset.labelLarge || '';
    if (average <= 1.05) return small;
    if (average >= 2.95) return large;
    if (Math.abs(average - 2) < 0.05) return perfect;
    return average < 2 ? `${small} / ${perfect}` : `${perfect} / ${large}`;
  }

  function render(target, summary) {
    const link = target.querySelector('[data-rac-review-link]');
    if (link) {
      link.textContent = `${summary.count} ${target.dataset.reviewLabel || ''}`.trim();
    }

    if (target.dataset.racReviewBlock === 'overview') {
      const score = target.querySelector('[data-rac-review-score]');
      if (score) score.textContent = summary.count ? summary.average.toFixed(1) : '0';
      renderStars(target, summary.average);
      target.hidden = false;
    } else {
      target.hidden = summary.sizeCount === 0;
      if (!summary.sizeCount) return;

      const position = ((summary.sizeAverage - 1) / 2) * 100;
      const description = sizeDescription(target, summary.sizeAverage);
      const meter = target.querySelector('[data-rac-size-meter]');
      const text = target.querySelector('[data-rac-size-summary]');
      target.style.setProperty('--size-fit-position', `${position}%`);
      if (meter) {
        meter.setAttribute('aria-label', (target.dataset.ariaTemplate || '[[value]]').replace('[[value]]', description));
      }
      if (text) {
        text.textContent = (target.dataset.summaryTemplate || '[[value]]').replace('[[value]]', description);
      }
    }
  }

  function load(target) {
    const handle = target.dataset.racHandle;
    const group = target.dataset.racGroup || '';
    if (!handle) return;
    const key = JSON.stringify([handle, group]);
    if (initialized.get(target) === key) return;
    initialized.set(target, key);
    target.hidden = true;
    target.dataset.racReviewState = 'loading';

    requestSummary(handle, group).then(summary => {
      if (!target.isConnected || initialized.get(target) !== key) return;
      render(target, summary);
      target.dataset.racReviewState = 'ready';
      target.dataset.racReviewCount = String(summary.count);
      target.dataset.racSizeAnswerCount = String(summary.sizeCount);
    }).catch(() => {
      if (!target.isConnected || initialized.get(target) !== key) return;
      target.hidden = true;
      target.dataset.racReviewState = 'error';
    });
  }

  function init(root) {
    if (root.matches && root.matches(SELECTOR)) load(root);
    root.querySelectorAll(SELECTOR).forEach(load);
  }

  window.relodeRacReviews = { init };

  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('product-info:loaded', event => {
    queueMicrotask(() => init(event.target.closest('main') || event.target));
  });
  document.addEventListener('click', event => {
    if (!(event.target instanceof Element)) return;
    const link = event.target.closest('[data-rac-review-link]');
    if (!link) return;
    const href = link.getAttribute('href') || '';
    if (!href.startsWith('#')) return;
    const target = document.getElementById(href.slice(1));
    if (!target) return;

    event.preventDefault();
    target.scrollIntoView({
      behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
      block: 'start'
    });
    window.history.replaceState(null, '', href);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(document), { once: true });
  } else {
    init(document);
  }
})();
